// 'XXX' is the ISO 4217 "no currency" code the backend stores for orders without priced rows,
// so it is not a currency an order can be priced in.
export const isRealCurrency = (currency?: string | null): currency is string => !!currency && currency !== 'XXX';

// A price-list currency of undefined means the price data has not loaded yet: show nothing
// and let the disabled save/next button block quietly. null means the data loaded and the
// client genuinely has no currency configured - only then is the missing-currency alert due.
export const shouldShowCurrencyMissingAlert = (
    currency: string | null | undefined,
    priceListCurrency: string | null | undefined,
): boolean => priceListCurrency !== undefined && !isRealCurrency(currency);
